import rest from '@exchange/libs/utils/rest/src';

const URL = '/questionnaire/client-categorisation-treatment';

export enum FuturesClientCategorisation {
  RETAIL = 'retail',
  PROFESSIONAL = 'professional',
}

export interface FuturesClientCategorisationTreatmentAnswer {
  questionId: 1;
  answer: FuturesClientCategorisation;
}

export type FuturesClientCategorisationTreatmentQuestionnaire = [FuturesClientCategorisationTreatmentAnswer];

type FuturesClientCategorisationTreatmentQuestionnaireResponse = {
  date: string;
  answers: FuturesClientCategorisationTreatmentQuestionnaire;
};

export default function Resource({ base }) {
  return {
    get: async (): Promise<FuturesClientCategorisation | undefined> => {
      try {
        const response: FuturesClientCategorisationTreatmentQuestionnaireResponse = await rest.request(
          {
            url: URL,
            base,
          },
          {
            useSubaccount: false,
          },
        );

        return response.answers[0].answer;
      } catch (e) {
        if ((e as { status: number }).status === 404) {
          return undefined;
        }

        throw e;
      }
    },
  };
}
